import React, { useEffect, useState } from "react";
import JobOfferEntry from "./JobOfferEntry/JobOfferEntry";
import classes from "./JobOfferListPage.module.css";
import Grid from "@mui/material/Grid";
import BackButton from "../../common/BackButton";
import { getJobOffers } from "../../../api/firestoreData";
import LoaderScreen from "../../common/LoaderScreen/LoaderScreen";

function JobOfferListPage() {
  const [jobOffers, setJobOffers] = useState(null);
  useEffect(() => {
    getJobOffers().then((res) => setJobOffers(res));
  }, []);

  if (!jobOffers) {
    return <LoaderScreen />;
  }
  return (
    <>
      <BackButton />
      <Grid
        container
        direction={"column"}
        justifyContent={"space-evenly"}
        alignItems={"center"}
        className={classes.grid}
        spacing={3}
      >
        {jobOffers.map((jobOffer) => (
          <Grid item className={classes.gridItem} key={jobOffer.id}>
            <JobOfferEntry
              photo={jobOffer.logo}
              name={jobOffer.name}
              location={jobOffer.location}
              time={jobOffer.dateTill}
              reward={jobOffer.reward}
              id={jobOffer.id}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default JobOfferListPage;
